export const WORD_PAYMENT_CONFIRMATION_BILL_ID_PARAMETRIZED_ROUTE = 'word-payment/:billid';
